import * as React from 'react';
import ProductSmokingHero from './modules/views/ProductSmokingHero';
import AppFooter from './modules/views/AppFooter';
import ProductHero from './modules/views/ProductHero';
import AppAppBar from './modules/views/AppAppBar';
import Airbnb from './modules/views/Airbnb';
import withRoot from './modules/withRoot';
import MapComponent from './modules/views/MapComponent'

function Index() {
  return (
    <React.Fragment>
      <AppAppBar />
      <ProductHero />
      <Airbnb />
      <ProductSmokingHero />
      <MapComponent />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
